import { tokenlist } from '@yodlpay/tokenlists';

export const STABLE_SYMBOLS = [
  'USDC',
  'USDT',
  'DAI',
  'USDGLO',
  'CRV',
  'xDAI',
  'wxDAI',
  'USDM',
];

export const USD_STABLE_SYMBOLS = STABLE_SYMBOLS.map((symbol) =>
  tokenlist.find((token) => token.symbol === symbol),
).filter((token) => token !== undefined);
